// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2wn0l","footer":"ModalFilter_footer__FQVza"};